<template>
  <div class="inline-flex items-center py-4 px-2 sm:py-5 md:py-5 lg:py-5 xl:py-5 sm:px-6 md:px-6 lg:px-6 xl:px-6">
    <!-- <span class="relative"> -->
      <!-- button background -->
      <span class="block w-8 h-8 rounded-full shadow-inner border-4" v-bind:class="[ status ? 'border-blue-700 bg-blue-100 text-blue-600' : 'bg-blue-200 border-blue-200']">
        <input type="checkbox" class="absolute cursor-pointer opacity-0 w-full h-full" v-model="buttonStatus" @change="$emit('toggle')"/>
        <div class="flex mr-2 w-5">
          <!-- button tick -->
          <div class="inline-block flex justify-center items-center m-1" v-if="status">
            <svg class="block fill-current transition-colors duration-200 ease-in-out" height="13" width="16"><path d="M14.293.293l1.414 1.414L5 12.414.293 7.707l1.414-1.414L5 9.586z"></path></svg>
          </div>
        </div>
      </span>
    <!-- </span> -->
    <!--<button @click="$emit('utterance', option.value.display)"><svg role="img" width="28px" height="28px" viewBox="0 0 24 24" stroke="#215e4e" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" fill="none" color="#215e4e"> <title>Read question text</title> <path d="M13 5v14l-5-4H3V9h5z"/> <path stroke-linecap="round" d="M13 14c1.5-1 1.5-3 0-4"/> <path d="M16 16C18.0858253 13.9141747 18.0858253 10.0858253 16 8M18 19C21.98552 15.01448 22.0076803 9.00768033 18 5"/></svg></button>-->
  </div>
</template>
<script>
export default {
  model: {
    prop: 'status',
    event: 'toggle'
  },
  data () {
    return {
      buttonStatus: this.status
    }
  },
  props: { status: Boolean },
}
</script>